import { WarningDisplay } from '../forms';
import React from 'react';

const DEFAULT_MESSAGE =
  'This reservation cannot be modified or cancelled right now because Start of Day ledger processing is in progress. Please try again later.';

interface Props {
  message?: string;
}

export const ReservationLockedWarning: React.FC<Props> = ({ message }) => (
  <WarningDisplay message={message ?? DEFAULT_MESSAGE} style={{ marginBottom: 15 }} />
);
